export const LOADING = 'LOADING'
export const SUCCEEDED = 'SUCCEEDED'
export const FAILED = 'FAILED'
export const IDLE = 'IDLE'
